<span class="img-placeholder" *ngIf="!component.content.url">
    <i class="bx bx-image"></i>
</span>
<div class="image-crop" id="image-crop-{{ component.id }}" [ngStyle]="contentService.getImageCropStyle(component)"
    (mousedown)="onMouseDown()" (mouseup)="onMouseUp()" (mouseover)="onMouseEnter()" (mouseout)="onMouseLeave()">
    <ng-container *ngIf="!statesService.getComponentState(component)">
        <img *ngIf="component.content.url" src="{{ component.content.url }}" alt="{{ component.content.alt }}" style="
                    height: 100%;
                    width: 100%;
                    position: absolute;
                    left: 0;
                    right: 0;
                  " />
    </ng-container>
     <ng-container *ngIf="statesService.getComponentState(component)">
        <img *ngIf="statesService.getComponentState(component)?.content?.url" src="{{ statesService.getComponentState(component)?.content?.url }}" alt="{{ statesService.getComponentState(component)?.content?.alt }}" style="
                    height: 100%;
                    width: 100%;
                    position: absolute;
                    left: 0;
                    right: 0;
                  " />
    </ng-container>
    
</div>